import { useEffect, useRef, useState } from 'react';
import { subscribeToStudentTrackJobs } from '../../services/TrackJobsService';
import { newlyFiledIds } from '../../services/trackJobsModel';

/**
 * A student's track jobs, live ("Add a track", 2026-09-26). Calls `onFiled`
 * when a job lands in studentTracks, so the page re-reads the strip and the
 * new cut appears in the lesson without a reload. The first snapshot never
 * counts as "newly filed": opening a lesson must not trigger a re-read for
 * jobs that landed yesterday.
 */
const useTrackJobs = (studentId, onFiled) => {
	const [jobs, setJobs] = useState([]);
	const prevRef = useRef(null);
	const onFiledRef = useRef(onFiled);
	onFiledRef.current = onFiled;

	useEffect(() => {
		prevRef.current = null;
		setJobs([]);
		if (!studentId) return undefined;
		const unsubscribe = subscribeToStudentTrackJobs(studentId, (rows) => {
			const prev = prevRef.current;
			prevRef.current = rows;
			setJobs(rows);
			if (prev && newlyFiledIds(prev, rows).length > 0 && onFiledRef.current) onFiledRef.current();
		});
		return unsubscribe;
	}, [studentId]);

	return jobs;
};

export default useTrackJobs;
